/*
 *
 * LanguageProvider
 *
 * this component connects the redux state language locale to the
 * IntlProvider component and i18n messages (loaded from `app/translations`)
 */

import React from 'react';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';
import { DEFAULT_LOCALE, DEFAULT_FORMATS, defaultCurrencyFormat } from '@quintoandar/js-intl';

const formats = defaultCurrencyFormat();

// eslint-disable-next-line react/prefer-stateless-function
export class LanguageProvider extends React.PureComponent {
  render() {
    return (
      <IntlProvider
        locale={this.props.locale}
        key={this.props.locale}
        defaultLocale={DEFAULT_LOCALE}
        formats={formats}
        defaultFormats={DEFAULT_FORMATS}
        messages={this.props.messages}
      >
        {React.Children.only(this.props.children)}
      </IntlProvider>
    );
  }
}

LanguageProvider.propTypes = {
  locale: PropTypes.string,
  messages: PropTypes.object,
  children: PropTypes.element.isRequired,
};

export default LanguageProvider;
